import {
  apiRequest,
  daftarperioderevisikeuangan,
  RevisiPeriodApprove,
  RevisiPeriodDelete,
  checkPeriodRapelIsFleg,
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      daftarperioderevisikeuangan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      RevisiPeriodApprove,
      {
        body: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      RevisiPeriodDelete,
      {
        body: query,
      },
      true
    );
  };

  checkPeriodRapelIsFleg = async (query) => {
    return await apiRequest(
      "get",
      checkPeriodRapelIsFleg,
      {
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
